import styled from 'styled-components';

export const CoverPage = styled.div`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.1);
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

export const CoverModal = styled.div`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.1);
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
